import "./Aesthetics.module.css";
import Header from "@/reusable_sections/Header";
import Banner from "./sections/Banner";
import HairRestorationExcellence from "./sections/HairRestorationExcellence";
import OurSignatureExpertise from "./sections/OurSignatureExpertise";
import TheDesignTimeline from "./sections/TheDesignTimeline";
import Footer from "@/reusable_sections/Footer";
export default function AestheticsPage() {
  return <div>
      <Header />
      <HairRestorationExcellence />
      <OurSignatureExpertise />
      <TheDesignTimeline />
      <Banner />
      <Footer />
    </div>;
}